import { GetAppointment } from "@/services/fhir";

/**
 * Lê um Appointment pelo id lógico no scheduling.
 * Mesmo padrão do resto do sistema (ClinicalEncounterActions, EHRRecords...):
 * BUSCA `?_id=<id>` e pega o Appointment do bundle. A leitura direta
 * `/Appointment/<id>` sai com `?_count=250` (default do GetAppointment) e o
 * scheduling responde 500.
 * Aceita também o recurso direto, como o EHRRecords faz.
 *
 * `locationReference` (`Location/<id>`, opcional): o scheduling filtra pela
 * Location do atendimento (como o dashboard, que busca com `actor=<location>`).
 * Quem convida passa a Location do Appointment; o convidado usa a da Task
 * (`Task.location`). Sem ela (convites antigos), busca só pelo `_id`.
 */
export async function fetchAppointmentById(
  appointmentId: string,
  locationReference?: string,
): Promise<fhir5.Appointment | undefined> {
  if (!appointmentId) return undefined;
  const response: fhir5.Bundle | fhir5.Appointment | undefined = await GetAppointment({
    _id: appointmentId as unknown as number,
    ...(locationReference && { actor: locationReference }),
  });
  if (response?.resourceType === "Appointment") return response;
  return response?.entry
    ?.map((entry) => entry.resource)
    .find(
      (resource): resource is fhir5.Appointment =>
        resource?.resourceType === "Appointment" && resource.id === appointmentId,
    );
}
